<template>
  <div>
    <md-toolbar>
      <h3 class="md-title">About</h3>
    </md-toolbar>
    <div class="about">
      <h1 class="title">Credovita Flapp Match</h1>
      <md-list>
        <md-list-item to="/terms">
          <md-icon>notes</md-icon>
          <div class="md-list-item-text">
            <span class="has-text-weight-medium">Legal</span>
            <span>Terms of Service and Privacy Policy</span>
          </div>
        </md-list-item>
      </md-list>
      <div class="copyright">
        <p class="is-size-7">© Credovita S.A.S.</p>
        <p class="is-size-7 has-text-grey-light">Illustrations by <a href="https://icons8.com/ouch">Icons 8 Ouch.pics</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
      name: "About"
  }
</script>

<style scoped>
  .title, .copyright {
    margin: 24px;
  }
</style>